<template>
  <div>
    <sweet-modal ref="config" width="50vw" class="modal-mailingboss" :title="$t('ct-mailingboss-select-list')">

      <div class="mailing-boss-lists-container">
        <div class="mailing-boss-lists-box">
          <div class="list-group-mailing-boss list-group">
            <div v-for="(list, index) in lists" :key="index" @click.prevent="changeList(list.general['list_uid'], list.general['main_list_uid'])"
                 class="list-item list-group-item"
                 :class="{'selectedList active': internal_config.listUid === list.general['list_uid']}"
                 :data-ref="list.general['list_uid']"
                 :data-main-list-uid="list.general['main_list_uid']"
                 :data-subscribe-url="list.url_subscribe">
              {{ list.general['name'] }}
            </div>
          </div>
        </div>

        <button class="btn btn-primary btn-create-new-list" @click="$refs.modalCreationChooseVersion.open()">
          <i class="svg-icon svgi-add-page"></i>{{ $t('ct-create-new-list')}}
        </button>

      </div>

      <button slot="button" class="btn btn-outline-light" @click="close">{{ $t('ct-cancel')}}</button>
      <button slot="button" class="btn btn-primary px-3" @click="listsOfUser" v-tooltip="{content: $t('ct-reload-list')}"><font-awesome-icon icon="sync" /></button>
      <button slot="button" class="btn btn-success" @click="selectList"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>

    <sweet-modal ref="modalCreationChooseVersion" width="25vw" :title="$t('ct-mailingboss-create-list')">
      <div class="mailing-boss-lists-container">
<!--        <button class="btn btn-primary btn-create-new-list Fmb-3" @click="openList">{{ $t('ct-create-new-list-mb4') }}</button>-->
        <a :href="`${mbDomain}/customer/lists`"
           class="btn btn-primary btn-create-new-list"
           target="_blank"
           @click="$refs.modalCreationChooseVersion.close()">{{ $t('ct-create-new-list-mb5') }}</a>
      </div>

      <button slot="button" class="btn btn-outline-light" @click="$refs.modalCreation.close()">{{ $t('ct-cancel')}}</button>
    </sweet-modal>

    <sweet-modal ref="modalCreation" width="25vw" :title="$t('ct-mailingboss-create-list')">
      <label class="w-100">
        {{ $t('ct-creation-list-name')}}
        <input type="text" class="form-control" name="creation-list-name" id="creation-list-name">
      </label>
      <label class="w-100">
        {{ $t('ct-creation-list-description')}}
        <input type="text" class="form-control" name="creation-list-description" id="creation-list-description">
      </label>
      <label class="w-100">
        {{ $t('ct-creation-list-from-name')}}
        <input type="text" class="form-control" name="creation-list-from-name" id="creation-list-from-name">
      </label>
      <label class="w-100">
        {{ $t('ct-creation-list-from-email')}}
        <input type="text" class="form-control" name="creation-list-from-email" id="creation-list-from-email">
      </label>
      <label class="w-100">
        {{ $t('ct-creation-list-reply-to')}}
        <input type="text" class="form-control" name="creation-list-reply-to" id="creation-list-reply-to">
      </label>

      <button slot="button" class="btn btn-outline-light" @click="$refs.modalCreation.close()">{{ $t('ct-cancel')}}
      </button>
      <button slot="button" class="btn btn-success" @click="createList"><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
    </sweet-modal>

    <sweet-modal ref="urls_modal" width="50vw" :title="$t('ct-mailingboss-url-list')">

      <label style="width: 100%;">
        <div class="label-url-mboss">{{$t('ct-subscribe-pending')}}</div>
        <button class="btn btn-outline-info text-break" style="max-width: 250px;"
                @click="changeURL('subscribe-pending')"
                ref="subscribe-pending">{{$t('ct-no-action')}}
        </button>
      </label>
      <label style="width: 100%;">
        <div class="label-url-mboss">{{$t('ct-subscribe-confirm')}}</div>
        <button class="btn btn-outline-info text-break" style="max-width: 250px;"
                @click="changeURL('subscribe-confirm')"
                ref="subscribe-confirm">{{$t('ct-no-action')}}
        </button>
      </label>
      <label style="width: 100%;">
        <div class="label-url-mboss">{{$t('ct-unsubscribe-confirm')}}</div>
        <button class="btn btn-outline-info text-break" style="max-width: 250px;"
                @click="changeURL('unsubscribe-confirm')"
                ref="unsubscribe-confirm">{{$t('ct-no-action', 'No Action')}}
        </button>
      </label>

      <button slot="button" class="btn btn-outline-light" @click="$refs.urls_modal.close()">
        {{ $t('ct-cancel')}}
      </button>
      <button slot="button" class="btn btn-success" @click="saveURL"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>

    </sweet-modal>
  </div>
</template>

<script>
import {
  createList,
  getCustomUrl,
  getLists,
  setCustomUrl
} from '../../../../../js/services/integrations-internas/mailingboss';
import {SweetModal} from 'sweet-modal-vue';

export default {
  name: 'ConfigModals',
  components: {
    SweetModal,
  },
  data() {
    return {
      element: false,
      internal_config_current: false,
      internal_config: false,
      callback: false,
      lists: [],
      mbDomain: '',
      appDomain: ''
    };
  },
  created () {
    this.mbDomain  = typeof process.env.MB_URL  !== 'undefined' ? process.env.MB_URL  : 'https://app.mailingboss.com';
    this.appDomain = typeof process.env.APP_URL !== 'undefined' ? process.env.APP_URL : 'https://cheetah-editor.builderall.com';
  },

  methods: {
    init(config, element, callback = false, modal) {
      this.internal_config = config;
      this.element = element;
      this.callback = callback;
      this.modal = modal;
    },
    open() {
      if (this.modal === 'config') { this.openListIndex() } else { this.openLink() }
    },

    openListIndex() {
      this.$loading.show();

      let vm = this;

      getLists(1, 10).then(res => {        
        if (res.data.data) { vm.lists = res.data.data }

        this.internal_config_current = {...this.internal_config};
        this.$refs.config.open();
      })
        .catch((error) => console.log('error mboss getlists', error))
        .finally(() => this.$loading.hide());
    },

    openLink() {
      let vm = this;

      vm.$refs['subscribe-pending'].textContent = this.$t('ct-no-action');
      vm.$refs['subscribe-confirm'].textContent = this.$t('ct-no-action');
      vm.$refs['unsubscribe-confirm'].textContent = this.$t('ct-no-action');

      if (this.internal_config.listUid) {
        getCustomUrl(this.internal_config.listUid).then(data => {
          data.data.data.forEach(url => {
            try {
              vm.internal_config.urlMboss[url.slug] = url.url;
              vm.$refs[url.slug].textContent = url.data;
            } catch (e) {
              console.log(url.slug + 'not found');
            }
          });
          this.$refs.urls_modal.open();
        })
          .catch((error) => console.log('error mboss link', error))
          .finally(() => this.$loading.hide());
      }
    },

    changeList(listUid, mainListUid) {
      this.internal_config.listUid = listUid;
      this.internal_config.mainListUid = mainListUid;
    },

    save() {
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.internal_config);
        this.$refs['config'].close();
      }
    },

    close() {
      if (this.internal_config.listUid === '') {
        $(this.element).detach();
      }

      if (this.internal_config_current) {
        if (this.internal_config.listUid !== this.internal_config_current.listUid)
          this.internal_config.listUid = this.internal_config_current.listUid;
        if (this.internal_config.mainListUid !== this.internal_config_current.mainListUid)
          this.internal_config.mainListUid = this.internal_config_current.mainListUid;
        $(this.element).detach();
      }

      $(this.element).css({zIndex: this.internal_config.zIndex});
      this.$refs.config.close();
    },

    openList() {
      $('#creation-list-name').val('');
      $('#creation-list-description').val('');
      $('#creation-list-from-email').val('');
      $('#creation-list-from-name').val('');
      $('#creation-list-reply-to').val('');
      this.$refs.modalCreationChooseVersion.close();
      this.$refs.modalCreation.open();
    },

    selectList() {
      let vm = this;
      let dataRef = $('.list-group-item.selectedList').attr('data-ref');
      let dataSubscribeUrl = $('.list-group-item.selectedList').attr('data-subscribe-url');
      let dataMainListUid = $('.list-group-item.selectedList').attr('data-main-list-uid');
      if (typeof dataRef === 'undefined') {
        vm.$snotify.warning(vm.$t('ct-list-not-selected-warning', 'List not selected'));

        return;
      }

      this.internal_config.listUid = dataRef;
      this.internal_config.url_subscribe = dataSubscribeUrl;
      this.internal_config.mainListUid = dataMainListUid;
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.internal_config);
        this.$refs.config.close();
      }
    },

    createList() {
      let value = $('#creation-list-name').val();
      let desc = $('#creation-list-description').val();
      let fromEmail = $('#creation-list-from-email').val();
      let fromName = $('#creation-list-from-name').val();
      let replyTo = $('#creation-list-reply-to').val();
      if (value == '' || desc == '' || fromEmail == '' || fromName == '' || replyTo == '') {
        this.$snotify.warning('All Fields are required!');
      } else {
        if (!this.validateEmail(fromEmail) && !this.validateEmail(replyTo)) {
          this.$snotify.warning('"From Email" and "Reply To" must be a valid email');
        } else {
          this.$loading.show();

          let data = {};

          data['listName'] = value;
          data['listDesc'] = desc;
          data['fromEmail'] = fromEmail;
          data['fromName'] = fromName;
          data['replyTo'] = replyTo;

          createList(data).then((result) => {
            this.$refs.modalCreation.close();
            this.listsOfUser();
          });
        }
      }
    },

    changeURL(where) {
      let vm = this;
      let splitedURL = vm.$refs[where].textContent.split(`${this.appDomain}/#/mboss-redirect/`);
      let objDefault = {};

      if (typeof splitedURL[1] !== 'undefined') {
        objDefault['valueID'] = splitedURL[1];
        objDefault['type']    = 'page';
      } else {
        if (typeof vm.$refs[where].textContent !== 'undefined' && vm.$refs[where].textContent !== 'No action') {
          objDefault['value'] = vm.$refs[where].textContent;
          objDefault['type']  = 'web';
        }
      }

      this.$root.$emit('linkComponentForm', { name: 'MailingBossFormComponent'}, objDefault, (data) => {      
        
        if (data.type === 'page') {
          vm.internal_config.urlMboss[where] = `${this.appDomain}/#/mboss-redirect/${data.valueID}`;
        } else {
          vm.internal_config.urlMboss[where] = data.value;
        }
        
        vm.$refs[where].textContent = vm.internal_config.urlMboss[where];
      });
    },

    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    listsOfUser: function() {
      let vm = this;
      getLists(false).then(res => {
        if (res.data.data) { vm.lists = Object.assign({}, vm.lists, res.data.data) }
      })
        .catch((error) => console.log('error mboss getlists', error))
        .finally(() => this.$loading.hide());
    },

    saveURL() {
      setCustomUrl(JSON.stringify(Object.assign({}, this.internal_config.urlMboss)), this.internal_config.listUid);
      this.$refs.urls_modal.close();
      this.$snotify.success('URL Saved!');
    }
  }
};
</script>

<style lang="scss">
  .modal-mailingboss .sweet-modal{

    @media (min-width: 1200px) {
      width: 30vw!important;
    }
  }

</style>
<style lang="scss" scoped>

  .mailing-boss-lists-container {

    .btn-create-new-list {
      width: 100%;
      margin: 0;
    }

    .mailing-boss-lists-box{
      max-height: 65vh;
      overflow: auto;

      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      /*border-radius: 3px;*/
      margin-bottom: 20px;
      padding: 20px 30px;
    }

    .list-group-mailing-boss {

      .list-group-item {
        background: #FAFBFC;
        border: 1px solid #DDDDDD;
        /*border-radius: 3px;*/
        margin-bottom: 10px;

        &.active{
          color: #656565;
          border-color: transparent;
          box-shadow: 0 0 1px 0.2rem rgba(0, 123, 255, 0.51);
        }
      }

      .list-group-item + .list-group-item{
        margin-top: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/MailingBossForm/ConfigModals.vue